module.exports = __webpack_public_path__ + "static/media/circle.953c9ca0.svg";